import { render, staticRenderFns } from "./chunai.vue?vue&type=template&id=64efa900&scoped=true"
import script from "./chunai.vue?vue&type=script&lang=js"
export * from "./chunai.vue?vue&type=script&lang=js"
import style0 from "./chunai.vue?vue&type=style&index=0&id=64efa900&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64efa900",
  null
  
)

export default component.exports